export const EMPTY_REGION_TEXT = 'Регион не найден';